module.exports = __webpack_public_path__ + "b68e64b2f589bd8380aa0481a9f758d8.png";